import ShapeModel from './shape-model'
import _ from 'lodash'
import { sectionEndpoint } from 'scoreboard/components/bootslide/object-selector-menu'
import createWob from '../create-wob'
import option from 'scoreboard/components/bootslide/menu-icon-option'
import AddDomainObjectEndpoint from 'scoreboard/components/bootslide/add-domain-object-endpoint'
import i18n from 'scoreboard/components/i18n'
import config from 'scoreboard/components/config'

import {
	SHAPE_TEXT_TYPE,
	SHAPE_TEXT_PROPERTY,
	SHAPE_TEXT_BOLD,
	SHAPE_COLOR_TYPE, DATA_SOURCE_PROPERTY
} from './shape-widget-properties'
import { SPECIFIC_FIELD } from './shape-text-type'
import ColorPicker from 'scoreboard/components/color-picker'
const { AUTO } = ColorPicker
import { PERFORMANCE } from './shape-color-type'
import { DEFAULT_WIDGET_PROPERTIES, DEFAULT_WOB_ATTRIBUTES } from './create-shape-widget-menu'
import constants from 'scoreboard/components/constants'
const { YES_NO, SCORED_TEXT, UNSCORED_TEXT } = constants

var AddBubbleOption = AddDomainObjectEndpoint.extend({
	selectorOptions: function(opt) {
		let selectorOptions = AddDomainObjectEndpoint.prototype.selectorOptions.apply(this, arguments)

		if (this.section === 'datasets') {
			selectorOptions.datasetsOnly = false
		} else if (this.section === 'scorecards') {
			if (!selectorOptions.objectParams) {
				selectorOptions.objectParams = {}
			}

			// Scoring type is needed for scorecard item bubbles; it's used to
			// determine if the Show Goal option should be available
			selectorOptions.objectParams.scoringType = true
		}

		return selectorOptions
	},

	add: function (node) {
		var widget = new ShapeModel(
			{
				properties: _.extend({}, DEFAULT_WIDGET_PROPERTIES, {
					section: this.section,
					domainObjectId: node.id,
					shape: 'ellipse',
					[DATA_SOURCE_PROPERTY]: defaultDataSourceProperty({
						section: this.section,
						domainObject: node
					}),
					[SHAPE_COLOR_TYPE]: PERFORMANCE,
					[SHAPE_TEXT_TYPE]: SPECIFIC_FIELD,
					[SHAPE_TEXT_PROPERTY]: 'label',
					[SHAPE_TEXT_BOLD]: true

				}, sectionDefaults[this.section])
			},
			{
				domainObject: node,
				section: this.model.get('section')
			})

		let wobAttributes = _.extend({},
			DEFAULT_WOB_ATTRIBUTES,
			{
				outlineColor: AUTO
			})

		createWob(this.canvas, widget,
			{ fetchData: true, wobAttributes },
			this.bootslideMenu)
	}
})

var sectionDefaults = {
	scorecards: {
		showTrend: true,
		periodDelta: '0'
	},
	initiatives: {
		periodDelta: '0'
	}
}

/**
 * Creates a menu item and submenu for adding a "bubble" shape widget to a
 * dashboard. Note that this creates a "shape" widget, just with properties
 * that are appropriate for a "Scorecard/Initiative Bubble"
 *
 * @param {String} section - the section of the domain object that will be
 * selected (eg 'scorecards' to select a scorecard item)
 *
 * @param {Object} addWidgetMenu - the bootslide menu for adding widgets
 */
function createBubbleShapeMenu (section, addWidgetMenu) {
	let labelCode = i18n.get(`dashboards.bubble.${section}`)
	return {
		label: i18n.get(labelCode),
		content: option('add-widget-bubble', labelCode),
		contentEndpoint: sectionEndpoint(
			addWidgetMenu, section, AddBubbleOption)
	}
}

function defaultDataSourceProperty ({ section, domainObject }) {
	if (section === 'initiatives') {
		return 'percent-complete'
	}

	if (domainObject.type !== 'metric') {
		return 'score'
	}

	let scoringType = config.scoringType(domainObject.scoringTypeId)
	if (scoringType.standardScoringType) {
		return scoringType.standardScoringType === YES_NO ? 'score' : 'actual'
	}

	switch (scoringType.kpiValueType) {
		case UNSCORED_TEXT:
			return null
		case SCORED_TEXT:
			return 'score'
		default: return 'actual'
	}
}

export default createBubbleShapeMenu
export { defaultDataSourceProperty }

createBubbleShapeMenu.__filename__ = 'dashboards/widgets/shape/create-bubble-shape-menu.js'
